/**
 * Starts decorative background videos only while they are actually displayed.
 * Desktop/mobile video pairs are toggled with CSS (display: none), but `autoplay` still downloads the hidden one.
 * Markup: <video data-lazy-bg-video muted loop playsinline preload="none"> (no `autoplay` attribute).
 */
(function () {
  if (window.__lazyBackgroundVideoInit) return;
  window.__lazyBackgroundVideoInit = true;

  const SELECTOR = 'video[data-lazy-bg-video]';

  function isDisplayed(video) {
    return video.getClientRects().length > 0;
  }

  function sync(video) {
    if (isDisplayed(video)) {
      if (!video.poster && video.dataset.poster) video.poster = video.dataset.poster;
      if (!video.paused) return;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    } else if (!video.paused) {
      video.pause();
    }
  }

  function syncAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(sync);
  }

  let resizeFrame = 0;
  function onResize() {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(() => syncAll());
  }

  // Hold playback until the page has loaded so the video stream does not compete with LCP resources.
  function start() {
    syncAll();
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    window.addEventListener('pageshow', onResize);
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', () => window.setTimeout(start, 1000), { once: true });
  }
  document.addEventListener('shopify:section:load', (event) => syncAll(event.target));
})();
